module.exports = __webpack_public_path__ + "img/jigglypuff-min.f5e67d5c.png";